import React, { useContext } from 'react';
import { SurveyPageContext } from '../../context/SurveyPageContext';
import { getConditionalQuestion } from '../../../domain/question';
import Question from '../Question/Question';

interface ConditionalQuestionProps {
  conditionalQuestionId: number;
}

const ConditionalQuestion: React.FunctionComponent<ConditionalQuestionProps> = ({
  conditionalQuestionId,
}) => {
  const { survey } = useContext(SurveyPageContext);
  const question = survey && getConditionalQuestion(conditionalQuestionId, survey);

  return question ? <Question question={question} /> : <></>;
};

ConditionalQuestion.displayName = 'ConditionalQuestion';

export default ConditionalQuestion;
